import { call, put, select } from 'redux-saga/effects';
import {
  fetchThirdPartySSOUrlFailure,
  fetchThirdPartySSOUrlSuccess,
  setThirdPartySSO,
} from '../actions';
import { getThirdPartySSOUrl, GetThirdPartySSOUrlResponse } from '../api';
import { FetchThirdPartySSOUrlRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { navigateToExternalPage } from 'utils/validation/common';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { ThirdPartySSO } from 'store/app/enums';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchThirdPartyUrlSaga(
  action: FetchThirdPartySSOUrlRequestAction
) {
  try {
    let err: ApiError | null;

    const { thirdPartySSO } = action.payload;
    if (
      thirdPartySSO.ssoLoginName &&
      thirdPartySSO.ssoCallbackUrl &&
      Object.values(ThirdPartySSO).includes(
        thirdPartySSO.ssoLoginName as ThirdPartySSO
      )
    ) {
      const response: GetThirdPartySSOUrlResponse = yield call(
        getThirdPartySSOUrl,
        thirdPartySSO
      );
      const ssoRedirectUrl: string = response.data.ssoRedirectUrl;
      err = checkResponse(response?.responseMessage);
      if (err) throw err;

      const message: MessageData = {
        title: i18n.t('notifications.user-logged-in'),
        description: i18n.t('notifications.redirecting'),
        type: MessageStates.INFO,
      };
      yield put(turnMessageOn(message));
      yield call(navigateToExternalPage, ssoRedirectUrl);
      yield put(fetchThirdPartySSOUrlSuccess());
      yield put(setThirdPartySSO(undefined));
    } else {
      yield put(push(routes.main));
      yield put(setThirdPartySSO(undefined));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchThirdPartySSOUrlFailure());
  }
}
